import React from 'react';
import { Card } from '../../../components/Card/Card';
import { withSuspendedCard } from '../../../util/suspense';
import { t } from '../../../locales/translate';
import { SalesOverTimePeriod } from '../../../generated/graphql';
import { useSuspenseQuery } from '@apollo/client';
import { graphql } from '../../../generated';
import { Stack } from '../../../components/Stack/Stack';
import { Tooltip } from '../../../components/Tooltip/Tooltip';
import { Icon } from '../../../components/Icon/Icon';
import { Text } from '../../../components/text/text';
import { AreaChart, Dataset } from '../../../components/Charts/AreaChart';
import { NoData } from '../../../components/NoData/NoData';
import { formatNumber } from '../../../util/formatters';

const DASHBOARD_SESSIONS = graphql(`
  query DashboardSessions($from: ISO8601DateTime, $to: ISO8601DateTime, $period: SalesOverTimePeriod) {
    statistics {
      persistedSessionsOverTime(during: { from: $from, to: $to }, period: $period) {
        total
        result {
          total
          date
        }
      }
    }
  }
`);

interface Props {
  from: Date;
  to: Date;
  period: SalesOverTimePeriod;
}

function Sessions$({ from, to, period }: Props): JSX.Element | null {
  const { data } = useSuspenseQuery(DASHBOARD_SESSIONS, {
    variables: {
      from: from,
      to: to,
      period: period,
    },
  });

  const total = data?.statistics?.persistedSessionsOverTime?.total;
  const sessionsData = data?.statistics?.persistedSessionsOverTime;
  const dataset: Dataset[] = [
    {
      title: t.component.sessions.period[period],
      values: sessionsData?.result.map((e) => e.total) || [],
      color: '#00EDFF80',
    },
  ];

  return (
    <Card
      title={
        <Stack line size="xxs">
          <p>{t.component.sessions.title}</p>
          <Tooltip small padding="medium" position="bottom" reference={<Icon name="info-circle" color="#909090" />}>
            <Text type="tooltip-content">{t.component.sessions.tooltip}</Text>
          </Tooltip>
        </Stack>
      }
      actions={
        sessionsData &&
        sessionsData.result.length > 0 && (
          <Text type="card-label">
            {t.component.sessions.total} {formatNumber(total, 0)}
          </Text>
        )
      }
    >
      {sessionsData && sessionsData.result.length > 0 ? (
        <AreaChart
          datasets={dataset}
          labels={sessionsData.result.map((e) => e.date)}
          showTimeOnXAxis={period === 'hour'}
        />
      ) : (
        <NoData description={t.component.sessions.noData} />
      )}
    </Card>
  );
}

export const Sessions = withSuspendedCard(Sessions$, { loadingTitle: t.component.sessions.title, loadingHeight: 488 });
